'use strict';

var d3 = require('d3');
var Scales = function Scales(width, fareRange) {
  var x = d3.scale.linear().domain(fareRange).range([15, width]);
  var y = 2;
  return {
    xScale: x,
    yScale: y
  };
};
module.exports = Scales;